module.exports = __webpack_public_path__ + "static/media/finish_survey.16d5d064.svg";